import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import type { BuilderQuestion } from '@/features/instruments/question-builder/types'
import { QuestionLivePreview } from '@/features/instruments/question-builder/QuestionBuilderPanels'
import {
  templateQuestionTypeIcon,
  templateQuestionTypeLabel,
} from '../lib/templateQuestionTypeLabel'

const CARD_BORDER = '#e8edf2'
const PROMPT = '#0d1b2a'
const TYPE_MUTED = '#6b7a90'
const PREVIEW_WELL_BG = '#f0f8fd'
const PREVIEW_WELL_BORDER = '#e8edf2'

type Props = Readonly<{
  index: number
  apiType: string
  prompt: string
  builderQuestion: BuilderQuestion
}>

export function TemplatePreviewQuestionCard({ index, apiType, prompt, builderQuestion }: Props) {
  const TypeIcon = templateQuestionTypeIcon(apiType)
  const typeLabel = templateQuestionTypeLabel(apiType)

  return (
    <Box
      data-testid={`instrument-template-preview-question-${index}`}
      sx={{
        bgcolor: '#ffffff',
        border: `1px solid ${CARD_BORDER}`,
        borderRadius: '14px',
        p: '20px',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.25} sx={{ mb: 1.5 }}>
        <Box
          sx={{
            bgcolor: '#e6f4fb',
            borderRadius: '8px',
            px: 1,
            py: 0.25,
            minWidth: 30,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: '12px', lineHeight: '18px', color: '#008cd0' }}>
            Q{index + 1}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.75,
            px: 1.375,
            py: 0.375,
            borderRadius: 999,
            bgcolor: '#f4f7fa',
            border: '1px solid #e4e9f0',
            height: 24,
          }}
        >
          {TypeIcon ? (
            <TypeIcon size={10} color={TYPE_MUTED} aria-hidden />
          ) : null}
          <Typography sx={{ fontSize: '12px', lineHeight: '18px', color: TYPE_MUTED }}>
            {typeLabel}
          </Typography>
        </Box>
      </Stack>

      <Typography
        sx={{
          fontWeight: 600,
          fontSize: '15px',
          lineHeight: '22.5px',
          color: PROMPT,
          mb: 1.5,
        }}
      >
        {prompt}
      </Typography>

      <Box
        sx={{
          bgcolor: PREVIEW_WELL_BG,
          border: `1px solid ${PREVIEW_WELL_BORDER}`,
          borderRadius: '10px',
          p: 1.625,
        }}
      >
        <QuestionLivePreview q={builderQuestion} showHeading={false} surface="survey" />
      </Box>
    </Box>
  )
}
